<template src="./privacy.html"></template>

<script>
  export default {}
</script>

<style>

</style>
